module.exports = __webpack_public_path__ + "img/icono_negocio.506a8711.png";